<template>
    <el-table
        size="small"
        border
        class="el-table-css insured-request-table"
        max-height="329"
        :data="this.dataTable"
        style="width: 100%;"
    >
        <el-table-column width="52" align="center" class-name="insured-request-table__action-cell">
            <template #default="scope">
                <button
                    type="button"
                    class="table-icon-btn table-icon-btn--info"
                    :aria-label="$t('insuredChanges')"
                    @click="infoRequest(scope.row.arId)"
                >
                    <i class="bi bi-info-circle" aria-hidden="true"></i>
                </button>
            </template>
        </el-table-column>
        <el-table-column prop="requestDateStr" label="Tarix" width="150" />
        <el-table-column prop="operTypeName" label="Əməliyyat növü" min-width="170">
            <template #default="{ row }">
                <span class="badge" :class="operTypeBadgeClass(row.operType)">
                    {{ row.operTypeName }}
                </span>
            </template>
        </el-table-column>
        <el-table-column label="Status" width="118" align="center" class-name="insured-request-table__status-cell">
            <template #default="scope">
                <RequestStatusBadge :row="scope.row" />
            </template>
        </el-table-column>
        <el-table-column prop="approverName" label="Məsul şəxs" min-width="160" />
        <el-table-column prop="descr" :label="$t('commonNotes')" min-width="160" show-overflow-tooltip />
        <el-table-column prop="statusNote" :label="$t('requestDecisionNote')" min-width="160" show-overflow-tooltip />
        <el-table-column width="52" align="center" class-name="insured-request-table__action-cell">
            <template #default="scope">
                <button
                    type="button"
                    class="table-icon-btn table-icon-btn--danger"
                    :disabled="!canDeleteRequest(scope.row)"
                    :title="$t('confirmDeleteRequest')"
                    @click="deleteRequest(scope.row)"
                >
                    <el-icon aria-hidden="true"><Delete /></el-icon>
                </button>
            </template>
        </el-table-column>
    </el-table>
    <div v-if="alert" class="app-toast-host">
        <soft-alert :color="alertColor" dismissible @dismiss="closeSnackbar">
            {{ alertColor == 'success' ? $t('operationSuccess') : $t('operationFailed') + errorId }}
        </soft-alert>
    </div>
</template>
<script>
import { Delete } from "@element-plus/icons-vue";
import { swalDialogClass } from "@/project/Source/helper.js";
import Source from "@/project/Source/claim.js";
import SoftAlert from "@/components/SoftAlert.vue";
import RequestStatusBadge from "@/project/Global/Components/RequestStatusBadge.vue";
import { canDeleteRequest } from "@/project/Source/requestStatus.js";

export default {
    name: "RequestTable",
    components: { SoftAlert, RequestStatusBadge, Delete },
    props: {
        dataTable: Array
    },
    data() {
        return {
            errorId: null,
            alert: false,
            alertColor: 'success'
        }
    },
    methods: {
        canDeleteRequest,
        getDate(val) {
            const str = String(val)
            return str.slice(0, -9)
        },
        infoRequest(arId){
            this.$emit('get-info', arId)
        },
        async deleteRequest(row) {
            this.$swal({
                title: this.$t("commonAreYouSure"),
                text: this.$t("confirmDeleteRequest"),
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: this.$t("commonCancel"),
                confirmButtonText: this.$t("commonConfirm"),
                customClass: swalDialogClass(),
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const deleteData = {
                        "requestCorrelationId": Date.now().toString(36) + Math.random().toString(36).substr(2),
                        "data": {
                            "arId": row.arId
                        }
                    }
                    Source.DropAccountRequestRequest(deleteData)
                        .then((response) => { 
                            if(response.data.isSuccess == undefined) {
                                this.$emit("get-req-table", 0);
                                this.alertColor = 'danger'
                                this.errorId = deleteData.requestCorrelationId
                            } else {
                                this.$emit("get-req-table", 1);
                                this.alertColor = 'success'
                            }
                            this.Notif();
                        })

                } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                    this.$swal.dismiss;
                }
            });
        },
        closeSnackbar() {
            this.alert = false;
        },
        Notif() {
            this.alert = true;
            setTimeout(this.closeSnackbar, 5000);
        },
        operTypeBadgeClass(type) {
            if (type === 1) return "badge--info";
            if (type === 2) return "badge--danger";
            if (type === 3) return "badge--warning";
            return "badge--muted";
        },
    }
};
</script>

<style scoped>
.badge--info {
  background: color-mix(in srgb, var(--bs-info) 18%, transparent);
  color: var(--bs-info);
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  font-weight: 600;
}
.badge--warning {
  background: rgba(245, 158, 11, 0.15);
  color: #d97706;
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  font-weight: 600;
}
.badge--success {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  font-weight: 600;
}
.badge--danger {
  background: rgba(220, 38, 38, 0.15);
  color: #dc2626;
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  font-weight: 600;
}
.badge--muted {
  background: rgba(120, 130, 145, 0.15);
  color: var(--app-text);
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  font-weight: 600;
}

.insured-request-table :deep(.el-table__cell) {
  vertical-align: middle;
}

.insured-request-table :deep(.insured-request-table__action-cell .cell) {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 0;
}

.insured-request-table :deep(.insured-request-table__status-cell .cell) {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
</style>
